import AsyncComponent from '~/components/AsyncComponent';
import {USER_PERMISSION_TYPE} from '~/utils/constants';

export default [
  {
    exact: true,
    path: '/login',
    component: AsyncComponent(() => import(/* webpackChunkName: "login" */ './Login')),
    authLevel: [USER_PERMISSION_TYPE.ANONYMOUS]
  },
  {
    path: '/sso-login',
    component: AsyncComponent(() => import(/* webpackChunkName: "SSOLogin" */ './SSOLogin')),
    authLevel: [USER_PERMISSION_TYPE.ANONYMOUS]
  },
  {
    path: '/site/:idp',
    component: AsyncComponent(() => import(/* webpackChunkName: "siteLogin" */ './IDP')),
    authLevel: [USER_PERMISSION_TYPE.ANONYMOUS]
  },
  {
    path: '/reset-password',
    component: AsyncComponent(() => import(/* webpackChunkName: "login" */ './ResetPassword')),
    authLevel: [USER_PERMISSION_TYPE.ANONYMOUS]
  },
  {
    path: '/forget-password',
    component: AsyncComponent(() => import(/* webpackChunkName: "forgetPassword" */ './ForgetPassword')),
    authLevel: [USER_PERMISSION_TYPE.ANONYMOUS]
  },
  {
    path: '/init-user',
    component: AsyncComponent(() => import(/* webpackChunkName: "initUser" */ './InitUser')),
    authLevel: [USER_PERMISSION_TYPE.ANONYMOUS]
  },
  {
    path: '/company-select',
    component: AsyncComponent(() => import(/* webpackChunkName: "companySelect" */ './SelectCompany')),
    authLevel: [USER_PERMISSION_TYPE.NORMAL, USER_PERMISSION_TYPE.OU_ADMIN, USER_PERMISSION_TYPE.SUB_ADMIN]
  },
  {
    path: '/portal',
    component: AsyncComponent(() => import(/* webpackChunkName: "login" */ './Portal')),
    authLevel: [USER_PERMISSION_TYPE.NORMAL, USER_PERMISSION_TYPE.OU_ADMIN, USER_PERMISSION_TYPE.SUB_ADMIN]
  },
  {
    path: '/admin',
    component: AsyncComponent(() => import(/* webpackChunkName: "admin" */ './Admin')),
    authLevel: [USER_PERMISSION_TYPE.OU_ADMIN, USER_PERMISSION_TYPE.SUPER_ADMIN, USER_PERMISSION_TYPE.SUB_ADMIN],
    routes: [
      {
        path: '/users',
        component: AsyncComponent(() => import(/* webpackChunkName: "users" */ './Admin/User')),
        authLevel: [USER_PERMISSION_TYPE.OU_ADMIN, USER_PERMISSION_TYPE.SUB_ADMIN]
      },
      {
        path: '/user/batch-import',
        component: AsyncComponent(() => import(/* webpackChunkName: "batchImport" */ './Admin/BatchImport')),
        authLevel: [USER_PERMISSION_TYPE.OU_ADMIN, USER_PERMISSION_TYPE.SUB_ADMIN]
      },
      {
        path: '/user/:id',
        component: AsyncComponent(() => import(/* webpackChunkName: "userDetail" */ './Admin/UserDetail')),
        authLevel: [USER_PERMISSION_TYPE.OU_ADMIN, USER_PERMISSION_TYPE.SUB_ADMIN]
      },
      {
        path: '/roles',
        component: AsyncComponent(() => import(/* webpackChunkName: "roles" */ './Admin/Role')),
        authLevel: [USER_PERMISSION_TYPE.OU_ADMIN, USER_PERMISSION_TYPE.SUB_ADMIN]
      },
      {
        path: '/role/:id',
        component: AsyncComponent(() => import(/* webpackChunkName: "roleDetail" */ './Admin/RoleDetail')),
        authLevel: [USER_PERMISSION_TYPE.OU_ADMIN, USER_PERMISSION_TYPE.SUB_ADMIN]
      },
      {
        path: '/apps',
        component: AsyncComponent(() => import(/* webpackChunkName: "apps" */ './Admin/App')),
        authLevel: [USER_PERMISSION_TYPE.OU_ADMIN, USER_PERMISSION_TYPE.SUB_ADMIN]
      },
      {
        path: '/app/:id/menu-groups',
        component: AsyncComponent(() => import(/* webpackChunkName: "MenuGroups" */ './Admin/MenuGroup')),
        authLevel: [USER_PERMISSION_TYPE.OU_ADMIN, USER_PERMISSION_TYPE.SUB_ADMIN]
      },
      {
        path: '/app/:id/menu-management',
        component: AsyncComponent(() => import(/* webpackChunkName: "MenuManagement" */ './Admin/MenuManagement')),
        authLevel: [USER_PERMISSION_TYPE.OU_ADMIN, USER_PERMISSION_TYPE.SUB_ADMIN]
      },
      {
        path: '/app/:id',
        component: AsyncComponent(() => import(/* webpackChunkName: "ShortcutApp" */ './Admin/ShortcutApp')),
        authLevel: [USER_PERMISSION_TYPE.OU_ADMIN, USER_PERMISSION_TYPE.SUB_ADMIN]
      },
      {
        path: '/user-groups',
        component: AsyncComponent(() => import(/* webpackChunkName: "userGroups" */ './Admin/UserGroup')),
        authLevel: [USER_PERMISSION_TYPE.OU_ADMIN, USER_PERMISSION_TYPE.SUB_ADMIN]
      },
      {
        path: '/security-settings',
        component: AsyncComponent(() => import(/* webpackChunkName: "securitySetting" */ './Admin/SecuritySetting')),
        authLevel: [USER_PERMISSION_TYPE.SUPER_ADMIN]
      },
      {
        path: '/plugins',
        component: AsyncComponent(() => import(/* webpackChunkName: "plugins" */ './Admin/Plugin')),
        authLevel: [USER_PERMISSION_TYPE.SUPER_ADMIN]
      },
      {
        path: '/super',
        component: AsyncComponent(() => import(/* webpackChunkName: "super" */ './Admin/Super')),
        authLevel: [USER_PERMISSION_TYPE.SUPER_ADMIN]
      },
      {
        path: '/plugin/:id',
        component: AsyncComponent(() => import(/* webpackChunkName: "plugin" */ './Admin/PluginDetail')),
        authLevel: [USER_PERMISSION_TYPE.OU_ADMIN]
      },
      {
        path: '/structures',
        component: AsyncComponent(() => import(/* webpackChunkName: "structures" */ './Admin/Structure')),
        authLevel: [USER_PERMISSION_TYPE.OU_ADMIN]
      },
      {
        path: '/structure/:id',
        component: AsyncComponent(() => import(/* webpackChunkName: "structureDetail" */ './Admin/StructureDetail')),
        authLevel: [USER_PERMISSION_TYPE.OU_ADMIN]
      },
      {
        path: '/sub-admins',
        component: AsyncComponent(() => import(/* webpackChunkName: "subAdmin" */ './Admin/SubAdmin')),
        authLevel: [USER_PERMISSION_TYPE.OU_ADMIN]
      },
      {
        path: '/sub-admin/create',
        component: AsyncComponent(() => import(/* webpackChunkName: "subAdminDetail" */ './Admin/SubAdminDetail')),
        authLevel: [USER_PERMISSION_TYPE.OU_ADMIN]
      },
      {
        path: '/sub-admin/:id',
        component: AsyncComponent(() => import(/* webpackChunkName: "subAdminDetail" */ './Admin/SubAdminDetail')),
        authLevel: [USER_PERMISSION_TYPE.OU_ADMIN]
      },
      {
        path: '/asset-permission',
        component: AsyncComponent(() => import(/* webpackChunkName: "assetPermission" */ './Admin/AssetPermission')),
        authLevel: [USER_PERMISSION_TYPE.OU_ADMIN, USER_PERMISSION_TYPE.SUB_ADMIN]
      },
      {
        path: '/ou-config',
        component: AsyncComponent(() => import(/* webpackChunkName: "ouConfig" */ './Admin/OUSetting')),
        authLevel: [USER_PERMISSION_TYPE.NORMAL, USER_PERMISSION_TYPE.OU_ADMIN, USER_PERMISSION_TYPE.SUB_ADMIN]
      },
      {
        path: '/assets',
        component: AsyncComponent(() => import(/* webpackChunkName: "assets" */ './Admin/AssetTree')),
        authLevel: [USER_PERMISSION_TYPE.OU_ADMIN, USER_PERMISSION_TYPE.SUB_ADMIN]
      },
      {
        path: '/domain-settings',
        component: AsyncComponent(() => import(/* webpackChunkName: "domain" */ './Admin/Domain')),
        authLevel: [USER_PERMISSION_TYPE.OU_ADMIN, USER_PERMISSION_TYPE.SUB_ADMIN]
      },
      {
        path: '/audit-log',
        component: AsyncComponent(() => import(/* webpackChunkName: "audit-log" */ './Admin/Audit')),
        authLevel: [USER_PERMISSION_TYPE.OU_ADMIN, USER_PERMISSION_TYPE.SUB_ADMIN]
      },
      {
        path: '/security-setting',
        component: AsyncComponent(() => import(/* webpackChunkName: "audit-log" */ './Admin/OUSecuritySetting')),
        authLevel: [USER_PERMISSION_TYPE.OU_ADMIN]
      }
    ]
  },
  {
    exact: true,
    path: '/:appId/:menuCode',
    component: AsyncComponent(() => import(/* webpackChunkName: "bse" */ './BSE')),
    authLevel: [USER_PERMISSION_TYPE.ANONYMOUS]
  },
  {
    path: '/',
    component: AsyncComponent(() => import(/* webpackChunkName: "home" */ './Home')),
    exact: true,
    authLevel: [USER_PERMISSION_TYPE.SUPER_ADMIN, USER_PERMISSION_TYPE.NORMAL, USER_PERMISSION_TYPE.OU_ADMIN, USER_PERMISSION_TYPE.SUB_ADMIN]
  },
  {
    path: '/not-found',
    component: AsyncComponent(() => import(/* webpackChunkName: "home" */ '../components/NotFound')),
    exact: true,
    authLevel: [USER_PERMISSION_TYPE.SUPER_ADMIN, USER_PERMISSION_TYPE.NORMAL, USER_PERMISSION_TYPE.OU_ADMIN, USER_PERMISSION_TYPE.SUB_ADMIN]
  }
];
